<template>
  <div>

    <v-row justify="center">
      <v-dialog v-model="dialogIndividual" width="1000px">
        <v-card>
          <v-card-text style="text-align: justify;">
            <div>
              <v-btn icon @click="dialogIndividual = false" style="float: right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <br>
              <br>
              <div style="background: #002C77; border-radius: 9px; text-align: center; width: 94%; margin: auto;">
                <div style="padding: 2%;">
                  <label style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 22px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas y protecciones
                    del </label>
                  <label style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 22px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;"><label
                      style="font-family: Helvetica; font-style: normal; font-weight: 700; 
                      font-size: 22px; line-height: 18px; letter-spacing: 0.02em; color: white; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">
                    </label> <br> Seguro Oncológico Clínica IRAM.
                  </label>
                </div>

              </div>


              <br>
              <br>

              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b>   Cobertura completa en tratamiento oncológico individual </b> </label>
              </div>


              <br>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura tiene como finalidad complementar el régimen previsional de salud del asegurado, sea Fonasa (B, C, D) o Isapre, proporcionando acceso a tratamientos, hospitalización para patologías oncológicas y seguimiento oncológico, con cobertura vitalicia mientras el asegurado mantenga su pago y contrato vigente.</label>
              </div>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura es de carácter asistencial y contempla una indemnización de UF 50 en caso de diagnóstico de cáncer. El derecho a la indemnización no procederá si el diagnóstico de cáncer es consecuencia de otro anterior cubierto por la póliza. Todos los tratamientos y prestaciones deben ser indicados sólo por Clínica IRAM, realizados en su propia Clínica o en centros derivados por la misma.</label>
              </div>
              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 5px">
                <label class="texto">La cobertura oncológica se inicia una vez que el paciente presenta el resultado de una biopsia (informe histopatológico), que confirma que tiene cáncer. La realización de esta biopsia es de cargo del asegurado.</label>
              </div>
              <br>

              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b>  Beneficios adicionales </b> </label>
              </div>

              <br>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto">La cobertura y beneficios adicionales es complementaria al sistema previsional de cada persona (Fonasa o Isapre), es decir cubrirá los valores copago no cubiertos por éstas.</label>
              </div>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de mama: </b> <br>
                  • 1 mamografía anual sin costo desde los 35 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <div style="padding-left: 9%; padding-right: 7%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de próstata:</b><br>
                  • 1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="buttonAceptar"
              elevation="0" text @click="dialogIndividual = false">
              Aceptar
            </v-btn>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>

    <div v-if="loadingPlans == false">

      <div class="plan-recomen">

        <v-col class="text-center">

          <label class="planFamiliarConveniente">Plan Seguro Oncológico</label>

        </v-col>
      
      </div>
      <div class="plan-valid">

        <v-col class="text-center">

          <label class="planFamiliarConvenienteSub">Válido para Fonasa e Isapre</label>

        </v-col>
      
      </div>

       <div class="plan">

        <v-col class="text-center" style="max-width: 90% !important;">

          <!-- 
          <div v-if="planDataAux.setDesc" class="superpuestoFam" >
            <p class="p-descFam"  style="margin-bottom: 0px !important;padding-top: 9px;">{{ planDataAux.valueDesc }} %  </p> 
            <p class="p-descFam"  style="margin-bottom: 0px !important;font-size: 12px;">DCTO</p> 
          </div> -->

          <p class="planFamiliarName">Precio mensual</p>

          <div style="display: flex; justify-content: center; height: 33px;">
            <p class="planFamiliarPrecio">{{ formatPrice(planData.values[0].priceCLP) }} *</p>
            <div>
              <p></p>   
              <p class="planFamiliarSubPrecio">   UF {{ (planData.values[0].price).toFixed(2) }}</p>   
            </div>
           
          </div>
         

          <label class="planFamiliarSubDetalle">* Valor de la UF al día de hoy, {{ currentDate }} .</label>
          
          <div class="planShield">
            <img :src=iconShield alt="Protecciones" class="imgShield" >
            <p class="planShieldDetalle">El Plan otorga <b style="color: #4F74E3;">atención y cobertura</b> completa de los gastos que implica el tratamiento, control y seguimiento del cáncer.</p>
          </div>
         
          <div class="planSubShield">
            <img :src=iconSand alt="Protecciones" class="imgSand" >
            <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de activación de 30 días contínuos.</p>
          </div>

          <p></p>

        </v-col>
      </div>

     
      <div class="plan-skin" style="border-radius: 0px 0px 0px 0px !important;">

        <v-col class="text-center">

          <!-- <br> -->

          <!-- <p class="planIndividualProtege"> <b>Protege tu salud y tu tranquilidad financiera</b></p> -->

          <!-- <p></p> -->

          <!-- <label class="planIndividualCaracteristicas">Características</label>

          <br> -->
          <br>

          <!-- <p class="planIndividualBeneficios">{{ planData.coverage[0].description }}
          </p>
          <p></p>
          <p class="planIndividualBeneficios">UF {{ ufFormat(planData.coverage[1].amount) }} {{
            planData.coverage[1].description }}
          </p>
          <p></p>
          <p class="planIndividualBeneficios">UF {{ ufFormat(planData.coverage[2].amount) }} {{
            planData.coverage[2].description }}
          </p> -->

          <p class="planIndividualBeneficios">Cubre tratamiento para todos los tipos de cáncer, incluso cáncer in situ y el tratamiento del cáncer a la piel.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">La atención oncológica es solo en  la ciudad de Santiago de Chile. Traslados y estadías no estarán cubiertos por el seguro.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Todo el tratamiento integral del paciente lo realiza Clínica IRAM, derivando a los profesionales y/o centros hospitalarios en convenio en la ciudad de Santiago.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Cubre la realización de exámenes y procedimientos necesarios para identificar el tipo y estado de extensión del cáncer.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Ejecución de tratamiento comprobado y multidisciplinario de la enfermedad (Cirugía, Quimioterapia y Radioterapia).
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Hospitalización como un todo. Incluye los días cama, derechos de pabellón, UTI intermedio, procedimientos diagnósticos intrahospitalarios.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Incluye todos los honorarios médicos: quirúrgicos, de radioterapeutas, de quimioterapeutas y honorarios del equipo paramédico quirúrgico.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Cobertura vitalicia mientras se mantenga el pago y la póliza vigente.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Ante diagnóstico de cáncer positivo, recibirás una indemnización de UF 50 para libre disposición.
          </p>
          <p></p>
          <p class="planSubTopes">Topes posteriores a tu cobertura de Fonasa o Isapre:
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Drogas antineoplásicas: tope UF 100 por cada tratamiento de quimioterapia.
          </p>
          <p></p>
          <p class="planIndividualBeneficios">Farmacia intrahospitalaria: medicamentos, insumos, materiales clínicos y banco de sangre: UF 4 tope por hospitalización.
          </p>

          <p style="margin-top: 13%;"></p>

          <!-- <br>
          <br>

          <hr class="planIndividualLinea"> -->


        </v-col>

      

        <br>

        <!-- <br> -->

      </div>

      <div class="plan-skin">

        <v-col class="text-center">
          <p class="planSubTopes2" style="text-align: center !important;">Estamos para aclarar tus dudas</p>
  
        </v-col>

        <div>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel style="margin-bottom: 2%; margin-top: 2%;">
              <v-expansion-panel-header>
                <span style="margin-left: 3%;">¿Este seguro tiene beneficios adicionales?</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Sí, este seguro cuenta con los siguientes beneficios:
                <ul>
                  <li>1 mamografía anual sin costo desde los 35 años para mujeres.</li>
                  <li>1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años para hombres.</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
           
            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header>
                <span style="margin-left: 3%;">¿Cómo uso mi seguro?</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Si te diagnostican cáncer, notifícalo a través de nuestro sitio web o por correo a 
                <a href="mailto:siniestros@sbins.cl">siniestros@sbins.cl</a> o al <strong>800 200 802</strong> 
                lo antes posible (máximo 30 días, salvo fuerza mayor).<br /><br />
                <strong>Documento requerido para la denuncia del siniestro:</strong>  
                Informe de biopsia con diagnóstico de cáncer confirmado.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header>
                <span style="margin-left: 3%;">¿Qué es la Clínica IRAM?</span> 
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Clínica IRAM cuenta con más de 45 años de trayectoria dedicados al tratamiento del cáncer. 
                Posee tecnología de primer nivel y un equipo médico multidisciplinario altamente calificado.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header>
                <span style="margin-left: 3%;">¿Puedo contratarlo si tengo Fonasa?</span> 
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Este seguro puede ser contratado con los tramos B, C y D de Fonasa. No incluye Fonasa “A” ni PRAIS.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header>
                <span style="margin-left: 3%;">Soy parte de las fuerzas de orden y seguridad de Chile ¿Puedo contratarlo?</span> 
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Sí, este seguro cubre FFAA, Carabineros, PDI.
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </div>

        <div class="plan-info">
          <button>
            <b>
              <u class="planIndividualVerDetalle" elevation="0" @click="InfoIndividual()">
                VER DETALLE
              </u>
            </b>
          </button>
        </div>

        <!-- <br> -->

        <v-btn class="button-desing" style="background-color: #FFFFFF; margin-bottom: 5%;" @click="validate()">
          <label style="color: #FFFFFF;">Continuar</label>
        </v-btn> 

        <!-- <br>
        <br> -->

      </div>

    </div>

  </div>
</template>

<script>
import LibreEleccion from "../assets/images/libreeleccion.png";
import iconShield from "../assets/images/shield-check.svg";
import iconSand from "../assets/images/time-sand.svg";
import ShieldService from "../services/shield.service";
import CryptoJS from 'crypto-js';

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Plan",
  props: ["planData", "index", "userData", "loadingPlans", "planDataAux", "servicesData", "plansOutDesc"],
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    formatterUF: new Intl.NumberFormat("es-CL"),
    LibreEleccion,
    iconSand,
    currentDate: "",
    iconShield,
    info: [['Isapre Individual', 'Isapre Familiar', 'Fonasa Individual', 'Fonasa Familiar'], ['100%', '100%', '100%', '100%'], ['50', '50', '50', '50'], ['30.000', '30.000', '30.000', '30.000'], ['5.000', '5.000', '5.000', '5.000'], ['50', '50', '50', '50'], ['10', '10', '10', '10'], ['0', '30.000', '0', '30.000'], ['0', '50', '0', '50']],
    indexInfo: '0',
    dialogIndividual: false,
    dialogFamiliar: false,
    document: null,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
  }),
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const today = new Date();
    this.currentDate = today.toLocaleDateString("es-CL"); 
  },
  methods: {
    ufFormat(price) {
      return this.formatterUF.format(price);
    },
    InfoFamiliar() {
      if (this.planData.name == 'Plan Familiar ISAPRE') {
        this.indexInfo = 1
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData.name == 'Plan Familiar FONASA') {
        this.indexInfo = 3
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogFamiliar = true
    },
    InfoIndividual() {
      if (this.planData.name == 'Plan Individual ISAPRE') {
        this.indexInfo = 0
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData.name == 'Plan Individual FONASA') {
        this.indexInfo = 2
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogIndividual = true
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    ufchange(uf) {
      let nn = uf.toString();
      let new_uf = nn.replace('.', ',')
      return new_uf;
    },
    async validate() {
      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      this.planDataAux.plan = this.planData;
      // console.log(this.planDataAux.plan);
      // console.log(this.planDataAux);
      // this.planDataAux.planOutDesc = this.plansOutDesc[this.index].values[0].priceCLP;

      // console.log(this.planDataAux);
      const planDataLocal = JSON.stringify(this.planDataAux);
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      sessionStorage.setItem('planData', encryptedPlanDataLocal);

      // console.log(this.planData.name);

      var namePlanAux = this.planData.name.split(' ');
      this.userData.typePlan = namePlanAux.includes('Familiar') ? 'Familiar' : 'Individual';

      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);

      try {

        await ShieldService.newCreateStep(this.userData, null, this.planDataAux, this.servicesData, 'Planes', tokenStep);

      } catch (error) {
        console.log("Cart Fail");
      }

      if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

        await ShieldService.updateContactActiveCampain(null, this.planDataAux, this.servicesData, 1);

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      }

      // console.log(namePlanAux);

      if (namePlanAux.includes('Familiar')) {
        this.$router.push({ path: '/og/beneficiarios' })
      } else if (!namePlanAux.includes('Familiar')) {
        this.$router.push({ path: '/og/dps' })
      }

    },
    parseNumber(n) {
      return new Intl.NumberFormat().format(n);
    },
  },
};
</script>

<style lang="scss" scoped>
.planFamiliarRecomendado {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 25px;
  gap: 8px;
  width: 171px;
  height: 22px;
  background: #A74CF2;
  border-radius: 5px;
  margin: auto;
  margin-top: 5%;
}

.planFamiliarConveniente {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFF;
  ;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarConvenienteSub {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFF;
  ;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarName {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #2D387C;
  // width: 200px;
  margin: auto;
  margin-top: 0%;
}

.planFamiliarPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #4F74E3;
  // margin: auto;
}

.planFamiliarSubPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: #2D387C;
  margin-bottom: 0px !important;
}

.planFamiliarSubDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2D387C;
}

.planShield{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // width: 577px;
  height: 46px;
  background: #ECF0FC;
  border-radius: 4px;
  padding-right: 2%;
  margin-top: 2%;
}

.imgShield {
  width: 50px;
  height: 50px;
  margin-left: 7px;
}

.imgSand {
  width: 15px;
  height: 15px;
  // margin: auto;
}

.planShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  width: 85ca7 !important;
}

.planSubShield {
  background: #F3F3F3;
  border-radius: 4px;
  // width: 578px;
  width: 100%;
  height: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 8px;
}

.planSubShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #2D387C;
  margin: auto;
  width: 400px;
}

.planFamiliarLinea {
  width: 214px;
  height: 0px;
  border: 0.946207px solid #FFFFFF;
  margin: auto;
}

.planFamiliarProtege {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2D3748;
  width: 250px;
  justify-content: center;
  margin: auto;
}

.planFamiliarCaracteristicas {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarBeneficios {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D3748;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 250px;
  text-align: justify;
  margin: 0 auto;
  margin-bottom: 10px;
  // text-indent: -22px;
  padding-left: 5px;
}

.planFamiliarBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -23px;
}


.planFamiliarVerDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #FFFFFF;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.elegirPlan {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  width: 238px;
  height: 37px;
  // top: calc(50% - 39px/2 + 100px);
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
  font-weight: 800;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0px;
  text-transform: uppercase;
}

.planIndividualName {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #343497;
  // width: 200px;
  margin: auto;
  margin-top: 9%;
}

.planIndividualPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #343497;
  margin: auto;
}

.planIndividualSubPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  color: rgba(53, 53, 53, 0.65);
  margin-bottom: 0px !important;
}

.planIndividualSubDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: rgba(58, 58, 58, 0.85);
}

.planIndividualLinea {
  width: 214px;
  height: 0px;
  border: 0.946207px solid #2D387C;
  margin: auto;
  margin-top: -7%;
}

.planIndividualProtege {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2D3748;
  width: 200px;
  justify-content: center;
  margin: auto;

}

.planIndividualCaracteristicas {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planSubTopes {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  // line-height: 140%;
  // line-height: 22px;
  // letter-spacing: 0.02em;
  text-align: left;
  color: #4F74E3;
}

.planSubTopes2 {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  // line-height: 140%;
  // line-height: 22px;
  // letter-spacing: 0.02em;
  text-align: left;
  color: #4F74E3;
}

.planIndividualBeneficios {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  // line-height: 140%;
  // line-height: 22px;
  letter-spacing: 0.01em;
  color: #282828;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 370px;
  text-align: justify;
  margin: 0 auto;
  margin-bottom: 10px;
  // text-indent: -22px;
  padding-left: 7px;
}

.planIndividualBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -36px;
}

.planIndividualVerDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #4040A3;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.texto {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.02em;
  color: #333333;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 800;
}

.plan-info {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4%;
}

.plan {
  // background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  background: #FFF;
  border: 1px solid #ECECEC;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  // border-radius: 10px 10px 0px 0px;
  width: 500px;
}

.plan-recomen {
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  border-radius: 10px 10px 0px 0px;
  width: 500px;
  height: 30px;
}

.plan-valid {
  background: #2D387C;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  width: 500px;
  height: 10px;
}

.buttonAceptar {
  background: #4F74E3;
  border-radius: 40px;  
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;
  font-size: 12px;
  width: 174px !important; 
  height: 40px !important;
  color: white !important;
  margin: auto;
}

.plan-skin {
  background: #FFFFFF;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // margin: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0px 0px 10px 10px;
  width: 500px;
  border-color: #ECECEC;
  border: 1px solid #ECECEC;
}

.superpuesto {
  content: 'Nuevo';
  margin-top: -4% !important;
  width: 55px !important;
  height: 48px;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  background: #4F74E3;
  border-radius: 0px 10px 0px 20px;
  margin-left: 269px;
  margin-bottom: -25px;
}

.p-desc {
  // font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin: auto;
}

.superpuestoFam {
  content: 'Nuevo';
  margin-top: -4.4% !important;
  width: 55px !important;
  height: 48px;
  justify-content: center;
  align-items: center;
  color: #2D387C;
  font-size: 14px;
  font-weight: bold;
  background: #ECECEC;
  border-radius: 0px 00px 0px 10px;
  margin-left: 243px;
  margin-bottom: -15px;
}

.p-descFam {
  // font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 14px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #2D387C;
  margin: auto;
}

.v-expansion-panel-header {
  background: #ECF0FC !important;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: #2D387C;
  border-radius: 10px !important;
  padding: 3px 20px;
  // height: 75% !important;
}

.v-expansion-panel::before {
  border-radius: 10px;
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none !important;
}

.v-expansion-panel {
  flex: 9 0 99%;
  max-width: 100%;
  position: initial !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.v-expansion-panels {
  margin: auto;
  width: 93% !important;
}

.text-expan {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 28px;
  color: #4D4D4D !important;
}


</style>